import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      name: "Electric Chimney Repair",
      img: "img/home/services/chimney_repair.webp",
    },
    {
      name: "Electric Chimney Installation",
      img: "img/home/services/chimney_installation.webp",
    },
    {
      name: "Gas Stove Repair & Services",
      img: "img/home/services/gas_repair.webp",
    },
    {
      name: "HOB Repair & Services",
      img: "img/home/services/HOB_repair.webp",
    },
  ];

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
          Our Services
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Professional installation, repair, and maintenance services for all
          your kitchen appliances.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.length > 0 &&
          services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex flex-col h-full"
            >
              <div className="relative">
                <img
                  className="w-full h-48 object-cover"
                  src={service.img}
                  alt={service.name}
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  {service.name}
                </h3>
                <div className="mt-auto">
                  <Link
                    to={"contact-us"}
                    state={{ message: `Inquiry for ${service.name}` }}
                    className="inline-flex items-center justify-center w-full px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-colors duration-300"
                  >
                    Inquiry Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Services;
